import { render, staticRenderFns } from "./cascader2.vue?vue&type=template&id=5190ceb3&scoped=true&"
import script from "./cascader2.vue?vue&type=script&lang=js&"
export * from "./cascader2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190ceb3",
  null
  
)

export default component.exports